var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-subheader',[_vm._v("Serviços Adicionais")]),_c('v-card',{attrs:{"width":"100%"}},[_c('base-header-information',{attrs:{"title":_vm.headerTitle,"description":_vm.headerDescription,"color":"indigo lighten-3"}}),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }